<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card header-tag="header" footer-tag="footer">
        <div slot="header">
          <h1>Werbungen - Freigabeliste</h1>
          <div class="card-header-actions"></div>
        </div>
        <b-card-body>
          <v-client-table
            v-if="getAdvertisementStatus"
            :columns="columns"
            :data="getAdvertisementApprovallist"
            :options="options"
            :theme="theme"
            id="dataTableAdvertisements"
            ref="advertisementOverviewTable"
          >
            <!-- ADVERTISEMENT DISPLAY MEDIA -->
            <div
              slot="advertisementdisplaymediafile"
              slot-scope="{ row }"
              @click="
                loadAdvertisementDisplaymediaURL({
                  advertisementid: row.advertisementid,
                });
                displayUserHint();
              "
            >
              {{ row.advertisementdisplaymediafile
              }}<i
                class="cil-hand-point-up"
                style="font-size: x-large; margin-left: 1vw; margin-top: 0.5vh"
              />
            </div>
            <!-- ADVERTISEMENT MEDIA -->
            <div
              slot="advertisementmediafile"
              slot-scope="{ row }"
              @click="
                loadAdvertisementMediaURL({
                  advertisementid: row.advertisementid,
                });
                displayUserHint();
              "
            >
              {{ row.advertisementmediafile
              }}<i
                class="cil-hand-point-up"
                style="font-size: x-large; margin-left: 1vw; margin-top: 0.5vh"
              />
            </div>
            <!-- STATUS -->
            <div slot="advertisementstatus" slot-scope="{ row }">
              {{ determineStatus(row.advertisementstatus) }}
            </div>
            <!-- TYPE -->
            <div slot="advertisementtype" slot-scope="{ row }">
              <template v-if="row.advertisementtype === 'Image'"
                ><i class="cil-image1" style="font-size: x-large"></i
              ></template>
              <template v-else
                ><i class="cil-video" style="font-size: x-large"></i
              ></template>
            </div>
            <!-- SETTINGS -->
            <div slot="settings" slot-scope="props">
              <b-dropdown variant="link" size="lg" no-caret>
                <template slot="button-content">
                  &#x2699;<span class="sr-only">Search</span>
                </template>
                <b-dropdown-item
                  @click="$event => deleteAd(props.row)"
                >Löschen</b-dropdown-item>
              </b-dropdown>
            </div>
          </v-client-table>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ClientTable, Event } from "vue-tables-2";
import { mapActions, mapGetters } from "vuex";

import notificationmixin from "../../mixins/notificationmixin";

Vue.use(ClientTable);

export default {
  name: "AdvertisementOverview",
  mixins: [notificationmixin],
  methods: {
    ...mapActions([
      "loadAdvertisements",
      "loadPublicitygroups",
      "loadAdvertisementDisplaymediaURL",
      "loadAdvertisementMediaURL",
      "deleteAd"
    ]),
    displayUserHint() {
      this.report(
        `Klicken Sie auf das Vorschaufenster um dieses zu schließen`,
        this.$toast
      );
    },
    determineStatus(status) {
      switch (status) {
        case "pending":
          return "In Überprüfung";
        case "confirmed":
          return "Bestätigt";
        case "rejected":
          return "Abgelehnt";
        default:
          return "Status konnte nicht ermittelt werden";
      }
    },
  },
  computed: {
    ...mapGetters([
      "getAdvertisementStatus",
      "getAdvertisementApprovallist",
      "getPublicitygroupStatus",
    ]),
  },
  components: {
    ClientTable,
    Event,
  },
  mounted: function () {
    if (!this.getAdvertisementStatus) {
      this.loadAdvertisements();
    }
    // load businessgroups for details view
    if (!this.getPublicitygroupStatus) {
      this.loadPublicitygroups();
    }
  },
  data() {
    return {
      columns: [
        "advertisementid",
        "advertisementtitle",
        "advertisementdisplaymediafile",
        "advertisementmediafile",
        "advertisementtype",
        "advertisementstatus",
        "advertisementcreationdate",
        "settings",
      ],
      options: {
        headings: {
          advertisementid: "ID",
          advertisementtitle: "Titel",
          advertisementdisplaymediafile: "Anzeigebild",
          advertisementmediafile: "Werbung",
          advertisementtype: "Typ",
          advertisementstatus: "Status",
          advertisementcreationdate: "Erstellungsdatum",
          settings: "Einstellungen",
        },
        hiddenColumns: ["advertisementid", "advertisementcreationdate"],
        sortable: [
          "advertisementid",
          "advertisementtitle",
          "advertisementdisplaymediafile",
          "advertisementmediafile",
          "advertisementsmediatype",
          "advertisementstatus",
        ],
        filterable: [
          "advertisementid",
          "advertisementtitle",
          "advertisementdisplaymediafile",
          "advertisementmediafile",
          "advertisementsmediatype",
          "advertisementstatus",
        ],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort",
        },
        sortField: "advertisementcreationdate",
        icons: {
          img: "fas fa-image",
          vid: "fas fa-video",
        },
        pagination: {
          chunk: 5,
          edge: false,
          nav: "scroll",
        },
        texts: {
          filter: "Filter",
          filterPlaceholder: "Filtern nach ...",
          columns: "Spalten",
          limit: "Einträge",
          count: "Zeige Werbungen {from} bis {to} von {count} Einträgen",
          noResults: "Keine Einträge vorhanden",
        },
        rowAttributesCallback: (row) => {
          switch (row.advertisementstatus) {
            case "pending":
              return { style: "background-color: #F7F9C0" };
            case "confirmed":
              return { style: "background-color: #C1FB99" };
            case "rejected":
              return { style: "background-color: #FAA0A0" };
            default:
              return {};
          }
        },
      },
      useVuex: true,
      theme: "bootstrap4",
      template: "default",
    };
  },
};
</script>
